// import Image1 from '../../assets/woman1.png'
// import Image1 from '../../assets/man.png'
import Image1 from '../../assets/man2.png'
// import Image3 from '../../assets/woman2.png'

export const Data = [
  {
    id: 1,
    image: Image1,
    title: 'Rahul Reddy V ',
    description:
      "I highly recommend Abhishek for his outstanding work as a full stack developer intern. He demonstrated good skills in React, Express, and PostgreSQL SQL. His ability to work independently and collaboratively made a significant impact on our team's success. He would be a valuable asset to any organization.",
  },
  // {
  //     id: 2,
  //     image: Image2,
  //     title: "Mark S.",
  //     description: "Provided creative insight and improvment to the project.",
  // },
  // {
  //     id: 3,
  //     image: Image3,
  //     title: "Gemma B.",
  //     description: "Fixed the glitch and made the site easier to use.",
  // },
]
